import { Switch } from '@nexelem/components';
import { get } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useFiltersContext } from '../../hooks';
import { FilterComponentBaseProps, FilterConfigWithValue } from '../../types/filter.types';

export type SwitchFilterProps = Omit<FilterComponentBaseProps, 'value' | 'isMultiple'> & {
  readonly leftContentText: string;
  readonly rightContentText: string;
};

export const SwitchFilter = ({ path, register, leftContentText, rightContentText }: SwitchFilterProps) => {
  const { onChange, filters } = useFiltersContext();
  const filterValue = get(filters, path, { value: false }) as FilterConfigWithValue<boolean | undefined>;

  useEffect(() => {
    register({
      path,
      isMultiple: false,
      value: false,
    });
  }, [path, register]);

  const handleIsSelected = useCallback(() => {
    onChange(path, {
      value: !filterValue.value,
      isMultiple: false,
    });
  }, [filterValue.value, onChange, path]);

  return (
    <Switch
      checked={!!filterValue.value}
      leftContentText={leftContentText}
      rightContentText={rightContentText}
      onClick={handleIsSelected}
    />
  );
};
